import Reflux                   from 'reflux';

const RoadBlockActions = Reflux.createActions(['setUpRoadBlocks', 'getRoadBlocks', 'clearRoadBlock']);

export default RoadBlockActions;



// WEBPACK FOOTER //
// ./modules/actions/roadblock_actions.js